<!--
 * @Author: Src
 * @Date: 2024-12-18 08:46:19
 * @LastEditTime: 2024-12-20 10:24:38
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/comments/CityField.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div>
        <!-- <el-input v-model="val" /> -->
        <el-select v-model="val" placeholder="请选择城市">
            <el-option v-for="item in regions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Watch, Model, Prop } from 'vue-property-decorator';

interface City {
    code: string; // 城市编号
    depth: number;
    id: number; // 城市id
    name: string;
    pid?: number;
    pinyin: string;
    pinyin2: string;
    province?: City;
}

@Component({})
export default class CityField extends Vue {
    val: any = '';
    options: any[] = [];

    @Prop({
        type: Array,
        default: () => [],
    })
    regions!: Array<{ id: number; name: string; city: City[] }>;

    @Watch('val')
    watchInternalVal(): void {
        if (this.val !== null) {
            this.$emit('change', String(this.val));
        } else {
            this.$emit('change', '');
        }
    }


    @Model('change', {
        type: String,
    })
    value!: any;

    @Watch('value')
    watchValue() {
        if (!this.value || this.value === '') {
            this.val = null;
            return;
        }
        this.val = Number(this.value);
    }

    mounted() {
        this.watchValue();
    }
}
</script>
